export const LOCAL_STORAGE_COUPON_KEY = "BP-checkout-coupon";
export const LOCAL_STORAGE_CHECKOUT_CART_PRICING = "BP-checkout-cart-pricing";
export const MY_BEATPORT_PREORDER_STORAGE_KEY = "BP-my-bp-preorder";
export const PLAYED_SESSION_STORAGE_KEY = "BP-player-played-tracks";
export const QUEUE_LOCAL_STORAGE_KEY = "BP-player-queue";
